<template>
  <!-- loader Start -->
  <div id="loading" :style="style">
    <div id="loading-center">
    </div>
  </div>
  <!-- loader END -->
</template>
<script>
import { dized } from '@/shared/config/pluginInit'
export default {
  name: 'Loader',
  props: {
    dark: { type: Boolean, default: false }
  },
  mounted () {
    this.init()
  },
  data () {
    return {
      style: 'background: var(--color-bg, #fff);'
    }
  },
  methods: {
    init () {
      dized.loaderInit()
    }
  }
}
</script>
